import { useState, useCallback } from 'react';
const initialSorting = {
  col: 'Sorted',
  colBase: 'Sorted',
  colSortAscending: true,
  row: 'Sorted',
  rowBase: 'Sorted',
  rowSortAscending: true,
};

const initialRankSorting = {
  col: 'Sorted',
  colBase: 'Sorted',
  colSortAscending: true,
  row: 'Measure',
  rowBase: 'Measure',
  rowSortAscending: true,
};

type Key = keyof typeof initialSorting;

const useSorting = (showRank?: any) => {
  const [sorting, setSorting] = useState(showRank ? initialRankSorting : initialSorting);

  const onSortingChange = useCallback(({ name, value, isAscending = true }: any) => {
    const type = name === 'Row Order' ? 'row' : 'col';
    setSorting(prev => {
      const baseKey = `${type}Base` as Key;
      const baseValue =
        value === 'alpha' || value === 'rank' || value === 'Measure' || value === 'Alphabetical' || value === 'Sorted'
          ? value
          : prev[baseKey];
      const sortingKey = `${type}SortAscending` as Key;
      const weightedValue = prev[type] === value && prev[sortingKey] === isAscending ? prev[baseKey] : value;

      return {
        ...prev,
        [type]: weightedValue,
        [baseKey]: baseValue,
        [sortingKey]: isAscending,
      };
    });
  }, []);

  return { sorting, onSortingChange, initialSorting, initialRankSorting, setSorting };
};

export default useSorting;
